import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetPerson2: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 11a4 4 0 100-8 4 4 0 000 8zm-6 10a6 6 0 0112 0m1-10a3 3 0 100-6m3.5 16a5 5 0 00-5-5" />
      </svg>
    </div>
  );
};

export default WidgetPerson2;
